module.exports = __webpack_public_path__ + "img/cappuccino.aab7ee01.png";